// Single reusable id-ID currency formatter (integer IDR, no decimals).
const idr = new Intl.NumberFormat("id-ID", {
  style: "currency",
  currency: "IDR",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

// Formats to "Rp10.500" (no decimal, no space) — matching the agreed message
// template. Returns null for invalid/unpurchasable prices.
export function formatIDR(value) {
  if (typeof value !== "number" || !Number.isFinite(value) || value <= 0) {
    return null;
  }
  return idr.format(value).replace(/\s|\u00A0/g, "");
}

export function isValidPrice(value) {
  return typeof value === "number" && Number.isFinite(value) && value > 0;
}
